const ua = window.navigator.userAgent
const uaLow = ua.toLocaleLowerCase()
const isLan = /localhost/.test(window.location.href)
const isMock = /127.0.0.1|localhost/.test(window.location.href)
const isLocation = isLan
const isWx = /MicroMessenger/i.test(ua)
const isAliPay = /alipayclient/.test(navigator.userAgent.toLocaleLowerCase())
const isAliPayMini = /miniprogram/.test(uaLow) && /alipay/.test(uaLow)
const isInBocApp = /bocapp/.test(window.navigator.userAgent)
const isBocApp = /bocapp/.test(window.navigator.userAgent)

const isIOS = /iPhone|iPod|iPad/i.test(ua)
const isAndroid = /android/i.test(ua)

const isDev = /dev\./.test(window.location.origin)
const isTest = /(127.0.0.1|test\.)/.test(window.location.origin)
const isProd = /(http[s]?:\/\/www\.phone580)/.test(window.location.origin)

const isFzsAndroid = !!(window.JsManager && window.JsManager.doSomethingByH5)
const isFzsIos = !!(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.iOSFYDH)
const isFzsApp = isFzsAndroid || isFzsIos

const env = {
  isLan,
  isMock,
  isLocation,
  isWx,
  isAliPay,
  isAliPayMini,
  isAndroid,
  isIOS,
  isInBocApp,
  isBocApp,

  isDev,
  isTest,
  isProd,

  isFzsAndroid,
  isFzsIos,
  isFzsApp
}

export default env

export {
  isLan,
  isMock,

  isLocation,
  isWx,
  isAliPay,
  isAliPayMini,
  isAndroid,
  isIOS,
  isInBocApp,
  isBocApp,

  isDev,
  isTest,
  isProd,

  isFzsAndroid,
  isFzsIos,
  isFzsApp
}
